import { gql } from 'graphql-request'

export const slideFragment = gql`
  fragment SlideFragment on Slide {
    id
    titulo
    corTitulo
    tamanhoTitulo
    subtitulo
    corSubtitulo
    tamanhoSubtitulo
    tituloBotao
    link
    linkTarget
    inicioDate
    fimDate
    arquivo {
      id
      nome
    }
    grupos {
      id
      nome
    }
    active
    createdDateTime
    emExibicao
  }
`
